import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
    selector: 'ifb-account-state-balance-update-dialog',
    templateUrl: './account-state-balance-update-dialog.component.html',
    styleUrls: ['./account-state-balance-update-dialog.component.css'],
    standalone: false
})
export class AccountStateBalanceUpdateDialogComponent {

  constructor(public dialogRef: MatDialogRef<AccountStateBalanceUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  static show(dialog: MatDialog, form: UntypedFormGroup): Observable<any> {
    return dialog.open(AccountStateBalanceUpdateDialogComponent, {
      width: '510px',
      data: { form: form },
      closeOnNavigation: true,
    }).afterClosed();
  }

}
